<template>
  <div>
    <label>Карта для предоплаты</label>
    <select v-model="selectedCard.card_id" disabled class="form-control">
      <option disabled value="0">Выберите карту</option>
      <!--      <option value="-1">Оплата на кошелёк</option>-->
      <option v-for="c in cards" v-if="c.status === 1" :value="c.id">[{{ c.id }}]
        <template v-if="c.type === 5">
          <span>QiWi кошелек {{ c.number }}</span>
        </template>
        <template v-else>
          <span>{{ printNumber(c.number) }}</span>
        </template>
        ({{ c.owner && c.owner.short_name || 'не указан' }}) <span v-if="c.balance">[{{
            c.balance
          }}]</span></option>
    </select>

    <label>Сумма для предоплаты</label>
    <input :disabled="true" @input="updatePrice"
           placeholder="Сумма для предоплаты"
           type="number" v-model="selectedCard.sum"
           class="form-control">

    <template v-if="priceCorrectionBlock">
      <div class="mt-1 mb-1" v-if="allowToMakeDiscount">
        <input id="check_2" type="checkbox" v-model="selectedCard.options.payFull">
        <label for="check_2" class="pointer">Заявка оплачена полностью (сделать скидку)</label>
      </div>
      <div v-if="!selectedCard.options.payFull && overPrice" class="alert alert-info">
        <p>Курьеру нужно получить <strong>{{ overPrice }}</strong>р наличными</p>
      </div>
    </template>
  </div>
</template>

<script>

export default {
  props: ['sum', 'cards', 'selectedCard', 'disableChange', 'drugsPrice', 'orderPrice'],
  data() {
    return {
      priceCorrectionBlock: false,
      allowToMakeDiscount: false,
      overPrice: 0,
    }
  },
  methods: {
    printNumber(num) {
      if (!num) return;
      return num.substr(0, 4) + ' ' + num.substr(4, 4) + ' ' + num.substr(8, 4) + ' ' + num.substr(12);
    },
    updatePrice() {
      this.priceCorrectionBlock = false;
      this.allowToMakeDiscount = false;
      this.overPrice = 0;
      this.selectedCard.options.payFull = false;
      if (+this.selectedCard.sum >= +this.orderPrice) return;

      const percentage = Math.round(+this.selectedCard.sum / +this.drugsPrice * 100);
      if (percentage >= 97) {
        this.selectedCard.options.payFull = true;
        this.allowToMakeDiscount = true;
      }
      if (percentage < 97 && percentage >= 85) {
        this.allowToMakeDiscount = true;
      }
      this.overPrice = +this.orderPrice - +this.selectedCard.sum;
      this.priceCorrectionBlock = true;
    }
  }
}

</script>
